import React from "react";
import PropTypes from "prop-types";

import {reachGoal} from "../../utils";

class Question extends React.Component {
  constructor(props) {
    super(props);

    const {question, step} = this.props;
    this.state = {
      value: question.range.min,
      answered: false,
      innerWidth: null,
    };

    // console.log("VAL", this.state.value);

    reachGoal(`v_${step + 1}`);

    this.handleChange = this.handleChange.bind(this);
    this.handleAnswer = this.handleAnswer.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (this.props.stepText !== prevProps.stepText) {
      const {question, step} = this.props;
      reachGoal(`v_${step + 1}`);
      this.setState({value: question.range.min, answered: false});
    }
  }

  componentDidMount() {
    const {innerWidth} = this.state;
    if (innerWidth === null) {
      this.setState({innerWidth: window.innerWidth});
    }
  }

  handleChange(event) {
    // event.preventDefault();

    const {answered} = this.state;
    if (answered === true) {
      return;
    }

    this.setState({value: parseFloat(event.target.value)});
  }

  handleAnswer(event) {
    // event.preventDefault();

    const {question, onAnswer} = this.props;
    const {value, answered} = this.state;

    if (answered === false) {
      this.setState({answered: true});
    } else {
      if (value >= question.answer.min && value <= question.answer.max) {
        onAnswer(true);
      } else {
        onAnswer(false);
      }
    }
  }

  render() {
    const {stepText, question, image} = this.props;
    const {value, answered, innerWidth} = this.state;
    const spanLeft =
      (((answered === true ? question.answer.value : value) -
          question.range.min) *
        100) /
      (question.range.max - question.range.min);

    // console.log(innerWidth);
    // console.log(spanLeft, value, question.range.min, question.range.max);

    let valueDim = question.range.dimMax;
    let valueText = value;
    let valueTextMin = question.range.min;
    let valueTextMax = question.range.max;
    let answerText = question.answer.value;

    if (question.range.dimChange === true) {
      if (answered === true) {
        valueDim =
          question.answer.value < 1
            ? question.range.dimMin
            : question.range.dimMax;
      } else {
        valueDim = value < 1 ? question.range.dimMin : question.range.dimMax;
      }

      valueText = value < 1 ? value * 1000 : value;

      answerText =
        question.answer.value < 1
          ? question.answer.value * 1000
          : question.answer.value;

      valueTextMin =
        question.range.min < 1 ? question.range.min * 1000 : question.range.min;
      // valueTextMax = question.range.max;
    }

    const imageClasses = [];
    if (answered === true) {
      imageClasses.push("question__img");
      imageClasses.push("result__img");
    } else {
      imageClasses.push("question__img");
    }

    if (
      (answered === true && stepText === "1/9") ||
      (answered === true && stepText === "5/9") ||
      (answered === true && stepText === "8/9")
    ) {
      imageClasses.push("result__img--width_260");
    }

    if (answered === true && stepText === "6/9") {
      imageClasses.push("result__img--width_140");
    }

    if (
      (answered === false && stepText === "5/9") ||
      (answered === false && stepText === "8/9")
    ) {
      imageClasses.push("question__img--width");
    }

    if (answered === false && stepText === "6/9") {
      imageClasses.push("question__img--width-6");
    }

    if (
      (answered === false && stepText === "1/9") ||
      (answered === false && stepText === "5/9") ||
      (answered === false && stepText === "8/9")
    ) {
      imageClasses.push("question__img--wide")
    }

    const rangeClasses = [];
    if (stepText === "1/9") {
    }
    if (spanLeft > 84) {
      rangeClasses.push("question__thumb--right");
    }

    if (17 < spanLeft < 84) {
      rangeClasses.push("question__thumb");
    }

    if (spanLeft < 17) {
      rangeClasses.push("question__thumb--left");
    }

    if (innerWidth < 450 && spanLeft > 68) {
      rangeClasses.push("question__thumb--width");
    }

    if (innerWidth < 450 && spanLeft < 15) {
      rangeClasses.push("question__thumb--width-left");
    }

    return (
      <>
        <h1 className="question__title">{stepText}</h1>

        {answered === false && (
          <p className="question__text">{question.text}</p>
        )}

        <div className="question__img-block">
          <div className={imageClasses.join(" ")}>
            <img
              className="calc__img"
              src={image}
              // src={`${process.env.PUBLIC_URL}/images/${question.image.src}`}
              // srcSet={`${process.env.PUBLIC_URL}/images/${question.image.srcSet} 2x`}
              // width="90"
              // height="90"
              // loading="lazy"
              alt=""
            />
          </div>
        </div>

        <div className="question__range">
          <div className="question__numbers">
            {spanLeft > 17 && (
              <span>
                {valueTextMin} {question.range.dimMin}
              </span>
            )}

            {spanLeft < 80 && (
              <span style={{marginLeft: `auto`}}>
                {valueTextMax} {question.range.dimMax}
              </span>
            )}
          </div>

          <input
            className="slider"
            type="range"
            name={"value"}
            id={"value"}
            value={answered === true ? question.answer.value : value}
            disabled={answered === true}
            min={question.range.min}
            max={question.range.max}
            step={question.range.step}
            onChange={this.handleChange}
          />
          <span className="range__container">
            <span className="range__bar">
              <span style={{width: `${spanLeft}%`}}></span>
            </span>
            <span
              className="range__bar-btn"
              style={{left: `${spanLeft}%`}}
            ></span>
          </span>
          {spanLeft > 84 ? (
            <span
              className={rangeClasses.join(" ")}
              style={{
                marginLeft: `calc(${spanLeft}% - 120px)`,
              }}
            >
              {answered === true ? answerText : valueText}
              {valueDim}
            </span>
          ) : (
            <span
              className={rangeClasses.join(" ")}
              style={{marginLeft: `${spanLeft}%`}}
            >
              {answered === true ? answerText : valueText}
              {valueDim}
            </span>
          )}
        </div>

        {answered === true && (
          <p
            className="question__result"
            dangerouslySetInnerHTML={{__html: question.answer.text}}
          ></p>
        )}

        <button className="button" type={"button"} onClick={this.handleAnswer}>
          {answered === true ? "Далее" : "Проверить"}
        </button>
      </>
    );
  }
}

Question.propTypes = {
  image: PropTypes.string.isRequired,
  step: PropTypes.number.isRequired,
  stepText: PropTypes.string.isRequired,
  // TODO: objectOf
  question: PropTypes.object.isRequired,
  onAnswer: PropTypes.func.isRequired,
};

export default Question;
